import { render, staticRenderFns } from "./verificate.vue?vue&type=template&id=db35d578&scoped=true"
import script from "./verificate.vue?vue&type=script&lang=js"
export * from "./verificate.vue?vue&type=script&lang=js"
import style0 from "./verificate.vue?vue&type=style&index=0&id=db35d578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db35d578",
  null
  
)

export default component.exports